import { Accordion, Box, Heading, Stack } from '@chakra-ui/react';

import { useGetAllFaqsQuery } from '@modules/help-support/api';
import Faqs from '@modules/help-support/components/sections/Faqs';

const FAQSection = () => {
    const { data } = useGetAllFaqsQuery({});

    if (!data || data?.faq?.length === 0) return <Box />;

    return (
        <Stack sx={{ my: 8 }}>
            <Heading
                as="h2"
                fontSize={{ base: 'xl', md: '4xl' }}
                sx={{ width: '99%' }}
                textAlign="left"
                px={{ base: 2, md: 0 }}
                mb={3}
                mx={0}
                fontWeight="medium"
            >
                Frequently Asked Questions
            </Heading>
            <Accordion px={{ base: 2, md: 0 }} defaultIndex={[0]} allowMultiple width="100%">
                {data?.faq &&
                    data?.faq?.length > 0 &&
                    data?.faq?.map((item, index) => (
                        <Faqs
                            key={`key ${index}`}
                            question={item.question}
                            answer={item.answer}
                            index={index}
                            count={data.count}
                        />
                    ))}
            </Accordion>
        </Stack>
    );
};

export default FAQSection;
